module.exports = __webpack_public_path__ + "img/sh-ta.f9539d1f.svg";